import React from 'react';
import styles from './index.module.less';
import { payTypeList } from './payList';

export function Ewallet(props) {
    const { ewalletList, amount } = props;

    const renderEwalletItem = () => {
        let list = [...ewalletList];
        if (list.indexOf(4) > -1) {
            list.splice(list.indexOf(4), 1);
            list.unshift(4);
        }
        if (list.indexOf(18) > -1) {
            list.splice(list.indexOf(18), 1);
            list.unshift(18);
        }
        if (list.indexOf(4) > -1 && list.indexOf(18) > -1) {
            list.splice(list.indexOf(4), 1);
        }
        return list.map(item => {
            if (item === 3 || item === 39) {
                return <li className={`${styles.pay_item} ${styles.ewallet_item}`} data-mode='ewallet'>
                    <span className={`${styles.pay_icon} ${styles.zalo_icon}`}></span>
                    <span className={styles.pay_title}>ZaloPay</span>
                </li>
            }

        })
    }

    return <div className={styles.content_item}>
        <ul className={styles.pay_list}>
            {renderEwalletItem()}
        </ul>
        <div className={styles.ewallet_card}>
            <div className={styles.ewallet_label}>Điền tài khoản MoMo dùng để thanh toán</div>
            <input type="number" placeholder='Nhập số điện thoại bắt đầu bằng số "0"' className={styles.ewallet_account} />
        </div>
        <button className={styles.send_btn}>Xác Nhận Thanh Toán</button>
    </div>
}